export default __webpack_public_path__ + "static/media/Krakensbane.d75db741.jpg";